import './index.scss';

import { ErrorMessage, Field, Form as FormikForm, Formik } from 'formik';
import React, { useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
// import { Redirect } from 'react-router-dom';
import * as Yup from 'yup';

import axios from '../../admin-axios';
import { ReactComponent as GasfloSVG } from '../../assets/Icons/Gasflow.svg';
import useActions from '../../hooks/useActions';

const validationSchema = Yup.object({
  new_password: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!').required('Required'),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('new_password'), undefined], 'Passwords must match')
    .required('Required')
});

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [passwordStrength, setPasswordStrength] = useState(0);
  const { user } = useSelector((state) => state.auth);
  const { changePasswordSuccess } = useActions();
  const history = useHistory();

  const initialValues = {
    new_password: '',
    confirm_password: ''
  };

  // let redirect = null;
  // if (!user?.id) {
  //   redirect = <Redirect to="/login" />;
  // }

  const handleInput = (event) => {
    const input = event.target.value;
    let strength = 0;
    if (input.match(/[a-z]+/)) {
      strength += 1;
    }
    if (input.match(/[A-Z]+/)) {
      strength += 1;
    }
    if (input.match(/[0-9]+/)) {
      strength += 1;
    }
    if (input.match(/[$@#&!]+/)) {
      strength += 1;
    }
    if (input.length >= 8) {
      strength += 1;
    }

    setPasswordStrength(strength);
  };

  let width = '20px';

  if (passwordStrength >= 2) {
    width = '20%';
  }
  if (passwordStrength >= 4) {
    width = '60%';
  }
  if (passwordStrength >= 5) {
    width = '96%';
  }

  return (
    <div className="reset_password d-flex justify-content-center align-items-center">
      <div className="reset_password_icon">
        <GasfloSVG />
        {/* {changePassword && ( */}
        {/*  <Alert variant="danger" style={{ opacity: error ? 1 : 0, height: '61px' }}> */}
        {/*    /!* You need to change your password before you can access the dashboard *!/ */}
        {/*    {error} */}
        {/*  </Alert> */}
        {/* )} */}
      </div>
      <div className="reset_password_box">
        <h3 className="text-center mb-2">Change Password</h3>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await axios.put(`https://gasflow.africa/v1/api/auth/default/${user.id}`, {
                password: values.new_password
              });
              changePasswordSuccess();
              setLoading(false);
              toast.success('Password Changed Successfully\nPlease Login In');
              history.push('/login');
            } catch (e) {
              setLoading(false);
              setError(e.message);
            }
          }}>
          {(formik) => {
            return (
              <FormikForm>
                {/* {error && ( */}
                {/*  <Alert className="reset_password_box_alert" variant="danger"> */}
                {/*    {error} */}
                {/*  </Alert> */}
                {/* )} */}
                <Alert
                  className="reset_password_box_alert"
                  style={{ opacity: error ? 1 : 0, height: '61px' }}
                  variant="danger">
                  {error}
                </Alert>
                <div className="mb-3">
                  <Field
                    type="password"
                    className="form-control reset_password_input mb-1"
                    placeholder="Enter New Password"
                    name="new_password"
                    onInput={handleInput}
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enter New Password"
                  />
                  <ErrorMessage component="div" className="text-danger ms-1" name="new_password" />
                </div>
                <div className="mb-3">
                  <Field
                    type="password"
                    className="form-control reset_password_input mb-1"
                    placeholder="Confirm Password"
                    name="confirm_password"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Enter Password Again"
                  />
                  <ErrorMessage
                    component="div"
                    className="text-danger ms-1"
                    name="confirm_password"
                  />
                </div>

                <div className="mb-4">
                  {loading ? (
                    <div className="d-flex justify-content-center w-100 h-100">
                      <Spinner animation="border" variant="dark" />
                    </div>
                  ) : (
                    <Button
                      disabled={!formik.isValid}
                      className="w-100 reset_password_button"
                      variant="primary"
                      type="submit">
                      Reset
                    </Button>
                  )}
                </div>
              </FormikForm>
            );
          }}
        </Formik>
        <div className="reset_password_guage">
          <div className="guage_bar">
            <div className="guage_bar_value" style={{ width: width }}>
              &nbsp;
            </div>
            <span style={{ backgroundColor: passwordStrength >= 2 ? '#f18888' : '' }}>&nbsp;</span>
            <span style={{ backgroundColor: passwordStrength >= 4 ? '#f18888' : '' }}>&nbsp;</span>
            <span style={{ backgroundColor: passwordStrength >= 5 ? '#f18888' : '' }}>&nbsp;</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
